(function () {
  app.directive('stripeAddPayment', ["PATH", "PLAID_ENV", "apiService", "$modal", function (PATH, PLAID_ENV, apiService, $modal) {
    return {
      restrict: 'E',
      // transclude: true,
      templateUrl: PATH.components + 'stripeAddPayment/view.html',
      scope: {
        onCreditCardAdded: '&',
        onBankAccountAdded: '&',
        inProgress: '=',
        buttonCaption: '=',
        buttonClasses: '='
      },
      link: function ($scope, $element) {
        // var plaidLink;
        // var PLAID_KEY;
        var stripe;
        var card;
        var STRIPE_KEY;
        var cardExpiry;
        var cardCvc;
        var postalCode;

        $scope.loading = true;
        $scope.authorization = {
          value: false
        };
        $scope.terms = {
          value: false
        };
        $scope.additionalExpenses = {
          value: false
        };
        $scope.termstabulate = {
          value: false
        };
        $scope.errorAuthoriazation = false;
        $scope.paymentMethod = 'credit_card';
        $scope.bank_account = {
          accountHolderType: 'individual',
          accountHolderName: ''
        };
        apiService.getSome('paymentservices/publickeys').then(function (res) {
          // PLAID_KEY = keys.plaidPublicKey;
          STRIPE_KEY = res.data.stripePublicKey;
          $scope.loading = false;
          init();
        });

        function init() {
          // plaidLink = Plaid.create({
          //   env: PLAID_ENV,
          //   clientName: 'Tabulate test',
          //   key: PLAID_KEY,
          //   product: ['auth'],
          //   selectAccount: true,
          //   onSuccess: function(public_token, metadata) {
          //     $scope.inProgress = true;
          //     $scope.onBankAccountAdded({result:{
          //       public_token:public_token,
          //       metadata:metadata
          //     }});
          //   },
          //   onExit: function(err, metadata) {
          //     $scope.inProgress = false;
          //     // The user exited the Link flow.
          //     if (err != null) {
          //       // The user encountered a Plaid API error prior to exiting.
          //     }
          //   },
          // });
          //
          // $scope.openPlaid = function(){
          //   plaidLink.open();
          // };

          $scope.changeMethod = changeMethod;

          stripe = Stripe(STRIPE_KEY);
          var elements = stripe.elements();
          var style = {
            base: {
              color: '#4c5557',
              fontSize: '14px',
              lineHeight: '45px',
              fontSmoothing: 'antialiased',
              '::placeholder': {
                color: '#bebcbb'
              }
            },
            invalid: {
              color: '#e5424d',
              ':focus': {
                color: '#303238'
              }
            }
          };

          card = elements.create('cardNumber', { style: style });
          cardExpiry = elements.create('cardExpiry', { style: style });
          cardCvc = elements.create('cardCvc', { style: style });
          postalCode = elements.create('postalCode', { style: style });

          refreshMount();
        }

        $scope.cardInvalid = false;
        $scope.expirationInvalid = false;
        $scope.cvcInvalid = false;
        $scope.zipInvalid = false;
        $scope.routingNumberInvalid = false;
        $scope.accountNumberInvalid = false;

        function refreshMount() {
          setTimeout(function () {
            card.mount('#stripeCard');
            cardExpiry.mount('#stripeExpiration');
            cardCvc.mount('#stripeCVC');
            postalCode.mount('#stripeZIP');
          }, 500);
        }

        $scope.save = function () {
          $scope.inProgress = true;

          $scope.cardInvalid = false;
          $scope.expirationInvalid = false;
          $scope.cvcInvalid = false;
          $scope.zipInvalid = false;
          $scope.errorMessage = null;

          if (!$scope.authorization.value) {
            $scope.inProgress = false;
            $scope.errorAuthoriazation = true;
            $scope.errorMessage = 'Please agree with the requirement';
            return false;
          }

          if (!$scope.terms.value) {
            $scope.inProgress = false;
            $scope.errorAuthoriazation = true;
            $scope.errorMessage = 'Please agree to the Terms and Conditions';
            return false;
          }

          if (!$scope.termstabulate.value) {
            $scope.inProgress = false;
            $scope.errorAuthoriazation = true;
            $scope.errorMessage = 'Please agree with the requirement';
            return false;
          }

          stripe.createToken(card).then(function (result) {
            if (result.error) {
              $scope.inProgress = false;
              $scope.errorMessage = result.error.message;
              switch (result.error.code) {
                case 'incomplete_number':
                case 'invalid_number':
                  $scope.cardInvalid = true;
                  break;
                case 'incomplete_expiry':
                case 'invalid_expiry_year_past':
                  $scope.expirationInvalid = true;
                  break;
                case 'incomplete_cvc':
                  $scope.cvcInvalid = true;
                  break;
                case 'incomplete_zip':
                  $scope.zipInvalid = true;
                  break;
              }
              $scope.$apply();
            } else {
              $scope.onCreditCardAdded({ result: result });
            }
          });
        };

        $scope.bankAccountModal = $modal({
          title: 'Bank Account',
          show: false,
          prefixClass: 'bank-account-modal',
          contentTemplate: PATH.apps + 'settings/payment/bankAccountModal.html'
        });

        $scope.creditCardModal = $modal({
          title: 'Credit Card',
          show: false,
          prefixClass: 'credit-card-modal',
          contentTemplate: PATH.apps + 'settings/payment/creditCardModal.html'
        });

        $scope.termsModal = $modal({
          title: 'Terms of Service',
          show: false,
          prefixClass: 'terms-modal',
          contentTemplate: PATH.apps + 'settings/payment/termsModal.html'
        });

        $scope.additionalExpensesModal = $modal({
          title: 'Additional expenses',
          show: false,
          prefixClass: 'additional-expenses',
          contentTemplate: PATH.apps + 'settings/payment/additionalExpenses.html'
        });

        $scope.paperlessModal = $modal({
          title: 'Paperless process',
          show: false,
          prefixClass: 'paperless-modal',
          contentTemplate: PATH.apps + 'settings/payment/paperlessModal.html'
        });

        $scope.saveBankAccount = saveBankAccount;

        function saveBankAccount() {
          $scope.inProgress = true;
          $scope.routingNumberInvalid = false;
          $scope.accountNumberInvalid = false;
          $scope.accountHolderInvalid = false;
          $scope.errorMessage = null;

          if (!$scope.authorization.value) {
            $scope.inProgress = false;
            $scope.errorAuthoriazation = true;
            $scope.errorMessage = 'Please agree with the requirement';
            return false;
          }

          stripe.createToken('bank_account', {
            country: 'US',
            currency: 'usd',
            routing_number: $scope.bank_account.routingNumber,
            account_number: $scope.bank_account.accountNumber,
            account_holder_name: $scope.bank_account.accountHolderName,
            account_holder_type: $scope.bank_account.accountHolderType
          }).then(function (result) {
            if (result.error) {
              $scope.inProgress = false;
              $scope.errorMessage = result.error.message;

              switch (result.error.param) {
                case 'bank_account[routing_number]':
                  $scope.routingNumberInvalid = true;
                  break;
                case 'bank_account[account_number]':
                  $scope.accountNumberInvalid = true;
                  break;
              }
              $scope.$apply();
            } else {
              $scope.onCreditCardAdded({ result: result });
            }
          });
        }

        function changeMethod(method) {
          $scope.inProgress = false;
          $scope.errorMessage = null;
          $scope.routingNumberInvalid = false;
          $scope.accountNumberInvalid = false;
          $scope.accountHolderInvalid = false;
          $scope.cardInvalid = false;
          $scope.expirationInvalid = false;
          $scope.cvcInvalid = false;
          $scope.zipInvalid = false;
          $scope.authorization = {
            value: false
          };
          $scope.errorAuthoriazation = false;
          $scope.bank_account = {
            accountHolderType: 'individual',
            accountHolderName: ''
          };

          if (method === 'credit_card') refreshMount();
          $scope.paymentMethod = method;
        }
      }
    };
  }]);
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/stripeAddPayment/directive.js